import classNames from "classnames";
import { ProfileMinimized } from "PFTypes/profile";

import css from "./chat.module.scss";
import { ChatHeaderOpenTitle } from "./chat_header_open_title";

type ChatHeaderTitleProps = {
  title: string;
  targetUrl: string | false;
  otherPerson: ProfileMinimized | null;
  selected: boolean;
  minimized: boolean;
  isBelow?: boolean;
};

const getTitleClassName = (selected: boolean, isBelow?: boolean) =>
  classNames(css.title, { [css.titleBelow]: !selected && isBelow });

export const ChatHeaderTitle = ({
  title,
  targetUrl,
  otherPerson,
  selected,
  minimized,
  isBelow
}: ChatHeaderTitleProps) => {
  const isOpenHeader = selected && !minimized;

  return (
    <div className={getTitleClassName(selected, isBelow)} data-qa-id="chat-window-title">
      {isOpenHeader ? (
        <ChatHeaderOpenTitle title={title} targetUrl={targetUrl} otherPerson={otherPerson} />
      ) : (
        <span>{title}</span>
      )}
    </div>
  );
};
